module.exports = __webpack_public_path__ + "img/campus-externe-tools.3e7bddeb.svg";